/* ============================================================
   カテゴリサイドバー JavaScript
   追加先: assets/collection-sidebar.js
   ============================================================ */

(function () {
  'use strict';

  // ---- PC サイドバー：開閉 ----
  document.querySelectorAll('[data-sidebar-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var isOpen = this.classList.contains('is-open');
      this.classList.toggle('is-open', !isOpen);
      this.setAttribute('aria-expanded', String(!isOpen));

var row = this.closest('.sidebar-tree__row');
var list = row ? row.nextElementSibling : this.nextElementSibling;
      if (list) {
        list.classList.toggle('is-open', !isOpen);
      }
    });
  });

  // ---- モバイル：カテゴリパネル開閉 ----
  var mobileBtn = document.querySelector('[data-mobile-filter-btn]');
  var mobilePanel = document.querySelector('[data-mobile-panel]');

  if (mobileBtn && mobilePanel) {
    mobileBtn.addEventListener('click', function () {
      var isOpen = mobilePanel.classList.contains('is-open');
      mobilePanel.classList.toggle('is-open', !isOpen);
      mobileBtn.classList.toggle('is-active', !isOpen);
      mobileBtn.textContent = isOpen
        ? '☰ カテゴリを絞り込む'
        : '✕ カテゴリを閉じる';
    });
  }
})();
